module.exports = __webpack_public_path__ + "img/badge-vo.eadf3175.svg";